import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-edit',
	path: '/secure/admin/EditIssueTypeScreenScheme([!%]?[\\w]*).jspa',
};
